import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.development';

export interface CrearRecetaResponse {
  mensaje: string;
  data: {
    id: number;
    folio: string;
  };
}

export interface SignosReceta {
  peso: number | null;
  estatura: number | null;
  saturacionOxigeno: number | null;
  frecuenciaCardiaca: number | null;
  glucosa: number | null;
  temperatura: number | null;
  presionSistolica: number | null;
  presionDiastolica: number | null;
  observaciones: string | null;
}

export interface PacienteReceta {
  nombre: string;
  apellido: string;
  segundoApellido: string;
  fechaNacimiento: string;
}

export interface MedicoReceta {
  nombre: string;
  apellidoPaterno: string;
  apellidoMaterno: string;
  cedulas: any[];
}

export interface EstudioReceta {
  nombre: string;
  indicaciones: string;
}

export interface MedicamentoReceta {
  medicamento: string;
  dosis: string;
  frecuencia: string;
  duracion: string;
  administracion: string;
}

export interface Receta {
  id: number;
  folio: string;
  expediente: string;
  fecha: string;
  hallazgos: string | null;
  impresion: string | null;
  padecimiento: string | null;
  signos: SignosReceta;
  paciente: PacienteReceta;
  medico: MedicoReceta;
  estudios: EstudioReceta[];
  medicamentos: MedicamentoReceta[];

  proximaCita: string | null;
  motivoProximaCita: string | null;
  motivoProximaConsulta?: string | null;
  metas: string | null;
  objetivos: string | null;
}

export interface ActualizarPlanSeguimiento {
  id: number;
  proximaCita: string | null;
  motivoProximaConsulta: string | null;
  metas: string | null;
  objetivos: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class RecetasService {
  private recetaApiUrl = `${environment.apiUrl}/receta`;

  constructor(private http: HttpClient) {}

  crearReceta(idAtencion: string): Observable<CrearRecetaResponse> {
    return this.http.post<CrearRecetaResponse>(this.recetaApiUrl, {
      idAtencion,
    });
  }

  obtenerReceta(idReceta: number): Observable<Receta> {
    return this.http.get<Receta>(`${this.recetaApiUrl}/${idReceta}`);
  }

  obtenerRecetasPorPaciente(pacienteId: string): Observable<Receta[]> {
    return this.http.get<Receta[]>(`${this.recetaApiUrl}/all/${pacienteId}`);
  }

  actualizarPlanSeguimiento(datos: ActualizarPlanSeguimiento): Observable<{
    mensaje: string;
    data?: Receta;
  }> {
    return this.http.patch<{
      mensaje: string;
      data?: Receta;
    }>(this.recetaApiUrl, datos);
  }
}
